import { ChevronRight } from 'lucide-react'

export const ToPageButton = ({
  text,
  href,
}: {
  text: string
  href: string
}) => {
  const fontSize = text.length > 21 ? 'text-xs' : 'text-sm'
  return (
    <div className="w-full z-50 p-3 md:w-[300px] md:mx-auto">
      <a
        href={href}
        className={`
          to-top-button
          button-color
          main-color
          block
          ${fontSize}
          w-full
          h-[50px]
          leading-[50px]
          text-white
          text-center
          relative
          font-bold
          rounded-md
          mt-[5px]
          cursor-pointer
          tracking-wider
          transition-all
          duration-300
          pr-10
          pl-5
          shadow-md
        `}
      >
        {text}
        <span className="absolute right-3 top-4 font-bold text-2xl text-white">
          <ChevronRight strokeWidth={3} width={20} height={20} />
        </span>
      </a>
    </div>
  )
}
